import { z } from 'zod';

export const AGENT_VERSION = '2026-10-agent-1';
export const agentPlanSchema = z.object({ steps: z.array(z.object({
  id: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_-]{0,39}$/),
  operation: z.string().min(1).max(80),
  label: z.string().min(1).max(160),
  dependsOn: z.array(z.string()).max(20).default([]),
  input: z.record(z.unknown()),
})).max(20), unsupportedGoals:z.array(z.string().min(1).max(300)).max(20).default([]) })
  .refine(plan=>plan.steps.length+plan.unsupportedGoals.length>0);
export type AgentPlannedStep = z.infer<typeof agentPlanSchema>['steps'][number];
export type AgentStepStatus = 'pending' | 'awaiting_input' | 'awaiting_approval' | 'running' | 'completed' | 'failed' | 'skipped';
export interface AgentStep extends AgentPlannedStep {
  status: AgentStepStatus;
  result?: unknown;
  error?: string;
  fields?: Record<string, string>;
  approvalToken?: string;
  approvalRevision?: string;
  approvalPreview?: unknown;
  checkpoint?: { id: string; [key: string]: unknown };
}
export interface AgentRun {
  id: string;
  prompt: string;
  status: 'running' | 'waiting' | 'completed' | 'cancelled' | 'failed';
  revision: number;
  steps: AgentStep[];
  createdAt: string;
  updatedAt: string;
}
